export const STATUS_TAG_VARIANTS = {
  soft: "soft",
  solid: "solid",
};

export const STATUS_TAG_PRESETS = {
  table: "table",
  header: "header",
};

export const STATUS_TAG_TONES = {
  warningSoft: {
    background: "var(--color-warning-subtle)",
    borderColor: "var(--color-warning-subtle)",
    color: "var(--color-warning-default)",
  },
  cyanSoft: {
    background: "var(--color-cyan-subtle)",
    borderColor: "var(--color-cyan-subtle)",
    color: "var(--color-cyan-800)",
  },
  fuchsiaSoft: {
    background: "var(--color-primary-subtle)",
    borderColor: "var(--color-primary-subtle)",
    color: "var(--color-fuchsia-default)",
  },
  successSoft: {
    background: "var(--color-success-subtle)",
    borderColor: "var(--color-success-subtle)",
    color: "var(--color-success-default)",
  },
  destructiveSoft: {
    background: "var(--color-destructive-subtle)",
    borderColor: "var(--color-destructive-subtle)",
    color: "var(--color-destructive-active)",
  },
  neutralSoft: {
    background: "rgba(var(--color-neutral-900-rgb), 0.04)",
    borderColor: "rgba(var(--color-neutral-900-rgb), 0.04)",
    color: "var(--color-foreground-muted)",
  },
  successSolid: {
    background: "var(--color-success-default)",
    borderColor: "var(--color-success-default)",
    color: "var(--color-success-subtle)",
  },
  primarySolid: {
    background: "var(--color-primary-default)",
    borderColor: "var(--color-primary-default)",
    color: "var(--color-success-subtle)",
  },
  neutralSolid: {
    background: "var(--color-muted-foreground)",
    borderColor: "var(--color-muted-foreground)",
    color: "var(--color-success-subtle)",
  },
  warningSolid: {
    background: "var(--color-warning-default)",
    borderColor: "var(--color-warning-default)",
    color: "var(--color-warning-subtle)",
  },
  destructiveSolid: {
    background: "var(--color-destructive-active)",
    borderColor: "var(--color-destructive-active)",
    color: "var(--color-destructive-subtle)",
  },
};

export const STATUS_TAG_CONFIG = {
  table: {
    pending: {
      label: "Pending",
      tone: "warningSoft",
      variant: STATUS_TAG_VARIANTS.soft,
    },
    in_review: {
      label: "In Review",
      tone: "cyanSoft",
      variant: STATUS_TAG_VARIANTS.soft,
    },
    upcoming: {
      label: "Upcoming",
      tone: "cyanSoft",
      variant: STATUS_TAG_VARIANTS.soft,
    },
    ongoing: {
      label: "Ongoing",
      tone: "fuchsiaSoft",
      variant: STATUS_TAG_VARIANTS.soft,
    },
    completed: {
      label: "Completed",
      tone: "successSoft",
      variant: STATUS_TAG_VARIANTS.soft,
    },
    canceled: {
      label: "Canceled",
      tone: "destructiveSoft",
      variant: STATUS_TAG_VARIANTS.soft,
    },
    daily: {
      label: "Daily",
      tone: "cyanSoft",
      variant: STATUS_TAG_VARIANTS.soft,
    },
    monthly: {
      label: "Monthly",
      tone: "fuchsiaSoft",
      variant: STATUS_TAG_VARIANTS.soft,
    },
    assigned: {
      label: "Assigned",
      tone: "cyanSoft",
      variant: STATUS_TAG_VARIANTS.soft,
    },
    not_assigned: {
      label: "Not Assigned",
      tone: "neutralSoft",
      variant: STATUS_TAG_VARIANTS.soft,
    },
    active: {
      label: "Active",
      tone: "successSoft",
      variant: STATUS_TAG_VARIANTS.soft,
    },
    open: {
      label: "Open",
      tone: "warningSoft",
      variant: STATUS_TAG_VARIANTS.soft,
    },
    closed: {
      label: "Closed",
      tone: "successSoft",
      variant: STATUS_TAG_VARIANTS.soft,
    },
    deactivated: {
      label: "Deactivated",
      tone: "destructiveSoft",
      variant: STATUS_TAG_VARIANTS.soft,
    },
    rejected: {
      label: "Rejected",
      tone: "neutralSolid",
      variant: STATUS_TAG_VARIANTS.soft,
    },
  },
  header: {
    ongoing: {
      label: "Ongoing",
      tone: "successSolid",
      variant: STATUS_TAG_VARIANTS.solid,
    },
    upcoming: {
      label: "Upcoming",
      tone: "primarySolid",
      variant: STATUS_TAG_VARIANTS.solid,
    },
    draft: {
      label: "Draft",
      tone: "neutralSolid",
      variant: STATUS_TAG_VARIANTS.solid,
    },
    verified: {
      label: "Verified",
      tone: "successSolid",
      variant: STATUS_TAG_VARIANTS.solid,
    },
    unverified: {
      label: "Unverified",
      tone: "warningSolid",
      variant: STATUS_TAG_VARIANTS.solid,
    },
    assigned: {
      label: "Assigned",
      tone: "successSolid",
      variant: STATUS_TAG_VARIANTS.solid,
    },
    open: {
      label: "Open",
      tone: "warningSolid",
      variant: STATUS_TAG_VARIANTS.solid,
    },
    closed: {
      label: "Closed",
      tone: "successSolid",
      variant: STATUS_TAG_VARIANTS.solid,
    },
    pending: {
      label: "Pending",
      tone: "warningSolid",
      variant: STATUS_TAG_VARIANTS.solid,
    },
    completed: {
      label: "Completed",
      tone: "successSolid",
      variant: STATUS_TAG_VARIANTS.solid,
    },
    canceled: {
      label: "Canceled",
      tone: "destructiveSolid",
      variant: STATUS_TAG_VARIANTS.solid,
    },
    active: {
      label: "Active",
      tone: "successSolid",
      variant: STATUS_TAG_VARIANTS.solid,
    },
    deactivated: {
      label: "Deactivated",
      tone: "destructiveSolid",
      variant: STATUS_TAG_VARIANTS.solid,
    },
    rejected: {
      label: "Rejected",
      tone: "neutralSolid",
      variant: STATUS_TAG_VARIANTS.solid,
    },
  },
};

const STATUS_ALIASES = {
  approved: "active",
  cancel: "canceled",
  cancelled: "canceled",
  close: "closed",
  complete: "completed",
  inactive: "deactivated",
  in_progress: "ongoing",
  inprogress: "ongoing",
  past: "completed",
  previous: "completed",
};

const normalizeStatusTagPreset = (preset, variant) => {
  if (preset && STATUS_TAG_CONFIG[preset]) return preset;
  return variant === STATUS_TAG_VARIANTS.solid
    ? STATUS_TAG_PRESETS.header
    : STATUS_TAG_PRESETS.table;
};

export const normalizeStatusTagStatus = (status) => {
  const normalized = String(status || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

  return STATUS_ALIASES[normalized] || normalized || "draft";
};

export const formatStatusTagLabel = (status) =>
  String(status || "")
    .replace(/[_-]+/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const getStatusTagConfig = ({
  status,
  preset,
  tone,
  variant = STATUS_TAG_VARIANTS.soft,
}) => {
  const normalizedStatus = normalizeStatusTagStatus(status);
  const normalizedPreset = normalizeStatusTagPreset(preset, variant);
  const presetConfig = STATUS_TAG_CONFIG[normalizedPreset] || {};
  const fallbackConfig =
    normalizedPreset === STATUS_TAG_PRESETS.header
      ? STATUS_TAG_CONFIG.header.draft
      : STATUS_TAG_CONFIG.table.pending;
  const config = presetConfig[normalizedStatus] || fallbackConfig;
  const resolvedTone = tone || config.tone;

  return {
    key: normalizedStatus,
    label: config.label || formatStatusTagLabel(status),
    preset: normalizedPreset,
    tone: resolvedTone,
    variant: config.variant || variant,
    style: STATUS_TAG_TONES[resolvedTone] || STATUS_TAG_TONES.neutralSolid,
  };
};

export const getStatusTagStyle = (status, variant = STATUS_TAG_VARIANTS.soft) =>
  getStatusTagConfig({ status, variant }).style;
